'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'API User Images',

    getDefaultProps: function getDefaultProps() {
        return {
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN'
        };
    },
    renderImages: function renderImages() {
        var imageData = this.props.apiUsersImageData;
        return imageData.map(function (data, index) {
            var imageProps = {
                className: 'l-vertical-align',
                src: data.imageUrl,
                height: data.style.height,
                width: data.style.width
            };
            return _react2['default'].createElement(
                'li',
                { className: 'm-feature-grid--list-item small-text-center', key: index },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-feature-grid--item-image-wrapper' },
                    _react2['default'].createElement('img', imageProps)
                )
            );
        });
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'small-12 small-centered small-text-center columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'l-padding-b-10' },
                    _react2['default'].createElement(
                        'h6',
                        { className: 'm-marketing-page--subheader-small c-ashen', style: { fontSize: 18 } },
                        this.props.apiUsersHeaderText
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'bg-plume m-feature-grid m-hs-companies--grid m-hs-companies--api--grid medium-12 columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-text-center' },
                        _react2['default'].createElement(
                            'ul',
                            { className: 'm-feature-grid--list-item-group small-block-grid-2 medium-block-grid-6' },
                            this.renderImages()
                        )
                    )
                )
            )
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/api-user-images.jsx
 ** module id = 1214
 ** module chunks = 0
 **/